<template>
  <div class="footer">
    <div class="footer-left">
      <div class="footer-logo"></div>
      <div class="footer-link">
        <span @click="gotoContact">Contact Us</span>
        <!-- <span class="link-gutter">|</span>
        <span @click="gotoJoin">Join Us</span> -->
        <span class="link-gutter">|</span>
        <span @click="gotoAbout">About Us</span>
      </div>
    </div>
    <div class="footer-right pb-1">
      <div class="fllowUs pb-1">Follow US</div>
      <div class="footer-rightIcon">
        <div class="facebook-purple-box">
          <a
            class="facebook-purple"
            href="https://www.facebook.com/shanghaieyeSMG"
            target="_blank"
          ></a>
        </div>
        <div class="x-purple-box">
          <a
            class="x-purple"
            href="https://twitter.com/ShanghaiEye"
            target="_blank"
          ></a>
        </div>
        <div class="youtube-purple-box">
          <a
            class="youtube-purple"
            href="https://www.youtube.com/channel/UCaxIsKnhxr6bfaJFQc67-rg"
            target="_blank"
          ></a>
        </div>
        <div class="unknown-purple-box">
          <!-- <a
            class="unknown-purple"
            href="https://www.instagram.com/shanghaieye/?hl=zh-cn"
            target="_blank"
          ></a> -->
          <a
            class="unknown-purple"
            href="https://instagram.com/shanghaieye?igshid=OGQ5ZDc2ODk2ZA=="
            target="_blank"
          ></a>
        </div>
        <div class="tiktok-purple-box">
          <a
            class="tiktok-purple"
            href="https://www.tiktok.com/@shanghaieye?lang=en"
            target="_blank"
          ></a>
        </div>
      </div>
    </div>

    <div class="pc-footer">
      © Copyright © 2017 Kankanews.com Inc. All rights Reserved. |
      上海广播电视台版权所有 |
      <a href="https://beian.miit.gov.cn/" target="_blank" style="color: #ccc"
        >沪ICP备10207042号-53</a
      >
      | <i class="police"></i> 沪公网安备 31010602002220
      | 互联网新闻信息服务许可证：31120170004
    </div>

    <div class="phone-footer">
      <div>© Copyright © 2017 Kankanews.com Inc. All rights Reserved.</div>
      <div>上海广播电视台版权所有</div>
      <div>
        <a href="https://beian.miit.gov.cn/" target="_blank" style="color: #ccc"
          >沪ICP备10207042号-53</a
        >
        | <i class="police"></i> 沪公网安备 31010602002220
        | 互联网新闻信息服务许可证：31120170004
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Footer",
  methods: {
    gotoJoin() {
      this.$router.push("/joinus");
    },
    gotoAbout() {
      this.$router.push("/aboutus");
    },
    gotoContact() {
      this.$router.push("/contact");
    },
  },
};
</script>

<style lang="less" scoped>
.pc-footer,
.phone-footer {
  display: none;
}
.facebook-purple-box {
  &:hover {
    border-color: #2479EE !important;
    a {
      background: url("~@/assets/imgs/layout/facebook_logo.png") no-repeat;
      background-size: 100% 100%;
    }
  }
  a {
    background: url("~@/assets/imgs/layout/facebook_purple.png") no-repeat;
    background-size: 100% 100%;
  }
}
.x-purple-box {
  &:hover {
    border-color: #fff !important;
    a {
      background: url("~@/assets/imgs/layout/x_white.png") no-repeat;
      background-size: 100% 100%;
    }
  }
  a {
    background: url("~@/assets/imgs/layout/x_purple.png") no-repeat;
    background-size: 100% 100%;
  }
}
.youtube-purple-box {
  &:hover {
    border-color: #FF0000 !important;
    a {
      background: url("~@/assets/imgs/layout/youtube_logo.png") no-repeat;
      background-size: 100% 100%;
    }
  }
  a {
    background: url("~@/assets/imgs/layout/youtube_purple.png") no-repeat;
    background-size: 100% 100%;
  }
}
.unknown-purple-box {
  &:hover {
    border-color: #E1147E !important;
    a {
      background: url("~@/assets/imgs/layout/unknown_logo.png") no-repeat;
      background-size: 100% 100%;
    }
  }
  a {
    background: url("~@/assets/imgs/layout/unknown_purple.png") no-repeat;
    background-size: 100% 100%;
  }
}
.tiktok-purple-box {
  &:hover {
    border-color: #fff !important;
    a {
      background: url("~@/assets/imgs/layout/douyin.png") no-repeat;
      background-size: 100% 100%;
    }
  }
  a {
    background: url("~@/assets/imgs/layout/tiktok_purple.png") no-repeat;
    background-size: 100% 100%;
  }
}
@media screen and (max-width: 768px) {
  .footer {
    position: relative;
    overflow-x: hidden;
    width: 100%;
    background: #260c59;
    display: block !important;
    .footer-left {
      width: 100%;
      overflow-x: hidden;
      text-align: center;
      .footer-logo {
        width: 5.4rem;
        height: 1.2rem;
        background: url("../../../assets/imgs/layout/footer-logo_purple.png") no-repeat;
        background-size: 100% 100%;
        margin: 0 auto;
        margin-top: 1.1rem;
      }
      .footer-link {
        letter-spacing: 1px;
        cursor: pointer;
        font-size: 14px;
        color: #867ead;
        margin-top: 0.3rem;
        .link-gutter {
          padding: 0 0.2rem;
        }
      }
    }
    .footer-right {
      width: 100%;
      // ppp
      .footer-rightIcon {
        display: flex;
        margin: 0.3rem auto;
        height: 1rem;
        padding: 0 1rem;
        justify-content: center;
        div {
          flex-grow: 0;
          border: 1px solid #867ead;
          margin: 0 8px 0 0;
        }
        a {
          width: 0.5rem;
          height: 0.5rem;
          display: block;
          cursor: pointer;
          margin: 0.25rem 0.25rem;
        }
      }

      .fllowUs {
        color: #ffffff;
        font-weight: bold;
        margin-top: 0.4rem;
        font-size: 0.52rem;
        text-align: center;
      }

      .facebook {
        background: url("~@/assets/imgs/layout/facebook.png") no-repeat;
        background-size: 100% 100%;
      }
      .facebook:hover {
        background: url("~@/assets/imgs/layout/facebook.png") no-repeat;
        background-size: 100% 100%;
        padding: 3px;
      }
      .tuite {
        background: url("~@/assets/imgs/layout/tuite-g.png") no-repeat;
        background-size: 100% 100%;
      }
      .tuite:hover {
        background: url("~@/assets/imgs/layout/tuite.png") no-repeat;
        background-size: 100% 100%;
        padding: 3px;
      }
      .youtube {
        background: url("~@/assets/imgs/layout/youtube-g.png") no-repeat;
        background-size: 100% 100%;
      }
      .youtube:hover {
        background: url("~@/assets/imgs/layout/youtube.png") no-repeat;
        background-size: 100% 100%;
        padding: 3px;
      }
      .tuite {
        background: url("~@/assets/imgs/layout/tuite-g.png") no-repeat;
        background-size: 100% 100%;
      }
      .tuite:hover {
        background: url("~@/assets/imgs/layout/tuite.png") no-repeat;
        background-size: 100% 100%;
        padding: 3px;
      }
      .unknown {
        background: url("~@/assets/imgs/layout/unknown-g.png") no-repeat;
        background-size: 100% 100%;
      }
      .unknown:hover {
        background: url("~@/assets/imgs/layout/unknown.png") no-repeat;
        background-size: 100% 100%;
        padding: 3px;
      }
      .music {
        background: url("~@/assets/imgs/layout/douyin_b.png") no-repeat;
        background-size: 100% 100%;
      }
      .music:hover {
        background: url("~@/assets/imgs/layout/douyin_h.png") no-repeat;
        background-size: 100% 100%;
        padding: 3px;
      }
      .sina {
        background: url("~@/assets/imgs/layout/xinlang-g.png") no-repeat;
        background-size: 100% 100%;
      }
      .sina:hover {
        background: url("~@/assets/imgs/layout/xinlang.png") no-repeat;
        background-size: 100% 100%;
        padding: 3px;
      }
    }
    .phone-footer {
      display: block;
      float: left;
      width: 100%;
      line-height: 16px;
      background: #0c0c0c;
      text-align: center;
      font-size: 12px;
      color: #cccccc;
      margin-top: 0.3rem;
      padding: 0.3rem;
      i {
        display: inline-block;
        height: 15px;
        width: 15px;
        background: url("~@/assets/imgs/layout/police.png") no-repeat;
        background-size: 100% 100%;
      }
    }
  }
}
@media screen and (max-width: 576px) {
  .footer .footer-right .footer-rightIcon div {
    flex-grow: 0;
    border: 1px solid #867ead;
    // margin: 0 8px !important;
  }
}
@media screen and (min-width: 768px) {
  .footer {
    position: relative;
    overflow: hidden;
    width: 100%;
    background: #260c59;
    display: block !important;
    .footer-left {
      float: left;
      .footer-logo {
        width: 2.64rem;
        height: 0.6rem;
        background: url("../../../assets/imgs/layout/footer-logo_purple.png") no-repeat;
        background-size: 100% 100%;
        margin-top: 0.5rem;
        margin-left: 3rem;
      }
      .footer-link {
        cursor: pointer;
        font-size: 14px;
        margin-left: 3rem;
        color: #867ead;
        margin-top: 0.1rem;
        .link-gutter {
          padding: 0 0.2rem;
        }
      }
    }
    .footer-right {
      float: right;
      margin-right: 3.6rem;
      .footer-rightIcon {
        margin-top: 0.15rem;
        display: flex;
        div {
          flex-grow: 0;
          width: 0.5rem;
          height: 0.5rem;
          border: 1px solid #867ead;
          margin: 0 10px 0 0;
          a {
            display: block;
            width: 0.22rem;
            height: 0.22rem;
            cursor: pointer;
            margin: 0 5px;
            // padding: 0.18rem;
            box-sizing: border-box;
            margin: 0.13rem;
          }
        }
      }
      .fllowUs {
        color: #ffffff;
        font-weight: bold;
        margin-top: 0.4rem;
        font-size: 0.3rem;
      }

      .facebook {
        background: url("~@/assets/imgs/layout/facebook-g.png") no-repeat;
        background-size: 100% 100%;
      }
      .facebook:hover {
        background: url("~@/assets/imgs/layout/facebook.png") no-repeat;
        background-size: 100% 100%;
      }
      .tuite {
        background: url("~@/assets/imgs/layout/tuite-g.png") no-repeat;
        background-size: 100% 100%;
      }
      .tuite:hover {
        background: url("~@/assets/imgs/layout/tuite.png") no-repeat;
        background-size: 100% 100%;
      }
      .youtube {
        background: url("~@/assets/imgs/layout/youtube-g.png") no-repeat;
        background-size: 100% 100%;
      }
      .youtube:hover {
        background: url("~@/assets/imgs/layout/youtube.png") no-repeat;
        background-size: 100% 100%;
      }
      .tuite {
        background: url("~@/assets/imgs/layout/tuite-g.png") no-repeat;
        background-size: 100% 100%;
      }
      .tuite:hover {
        background: url("~@/assets/imgs/layout/tuite.png") no-repeat;
        background-size: 100% 100%;
      }
      .unknown {
        background: url("~@/assets/imgs/layout/unknown-g.png") no-repeat;
        background-size: 100% 100%;
      }
      .unknown:hover {
        background: url("~@/assets/imgs/layout/unknown.png") no-repeat;
        background-size: 100% 100%;
      }
      .music {
        background: url("~@/assets/imgs/layout/douyin_b.png") no-repeat;
        background-size: 100% 100%;
      }
      .music:hover {
        background: url("~@/assets/imgs/layout/douyin_h.png") no-repeat;
        background-size: 100% 100%;
      }
      .sina {
        background: url("~@/assets/imgs/layout/xinlang-g.png") no-repeat;
        background-size: 100% 100%;
      }
      .sina:hover {
        background: url("~@/assets/imgs/layout/xinlang.png") no-repeat;
        background-size: 100% 100%;
      }
    }
    .pc-footer {
      display: block;
      float: left;
      width: 100%;
      height: 0.4rem;
      line-height: 0.4rem;
      background: #0c0c0c;
      text-align: center;
      font-size: 12px;
      color: #cccccc;
      margin-top: 0.2rem;
      i {
        display: inline-block;
        height: 10px;
        width: 10px;
        background: url("~@/assets/imgs/layout/police.png") no-repeat;
        background-size: 100% 100%;
      }
    }
    .backtop {
      background: #00a5e5;
      height: 0.4rem;
      width: 0.4rem;
      position: absolute;
      right: 0.1rem;
      top: -0.2rem;
      font-size: 0.3rem;
      color: #ffffff;
      text-align: center;
      line-height: 0.4rem;
      cursor: pointer;
    }
  }
}
</style>
